var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"popper-class":"page-home-tooltip-class","popper-options":{
    removeOnDestroy: true,
  },"effect":"dark","placement":"top"}},[_c('div',{staticClass:"tooltip-content",attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.tooltip)},slot:"content"}),_c('img',{staticClass:"toottip-icon",attrs:{"src":require("@hotelcem/assets/imgs/info.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }